import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Action } from "material-table";
import { MentorLocalizations } from "../../../Shared/sharedTypes";
import { ActiveSessionStub } from "../../../Shared/GeneratedTypes";
import MaterialTable from "../MaterialTable/MaterialTable";
import {
    Avatar,
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    ListItemText,
    SvgIconProps,
    Popover,
    Theme,
    createStyles,
    Typography,
    Button,
} from "@material-ui/core";
import moment from "moment";
import Util from "../../../Shared/utilties";
import { AssignmentInd, Assistant, Flag } from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
            overflow: "hidden",
            //backgroundColor: theme.palette.background.paper
        },
        gridList: {
            // flexWrap: 'nowrap'
        },
        popover: {
            pointerEvents: "none",
        },
        paper: {
            padding: theme.spacing(1),
        },
        large: {
            width: theme.spacing(40),
            height: theme.spacing(40),
        },
    })
);

interface propTypes {
    classes?: any;
    forwardedRef?: any;
    activeMentors: ActiveSessionStub[];
    localizations: MentorLocalizations;
    refreshTimer: number;
    refreshNow: () => void;
}

export default function ActiveQueueTable(props: propTypes) {
    const classes = useStyles();
    const { activeMentors } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [currentlySelected, setCurrentlySelected] = React.useState<null | ActiveSessionStub>(null);

    function selectOnGuideStream(onSight: ActiveSessionStub | null) {
        // setActive(onSight);
    }

    const handleClick = (onSight: ActiveSessionStub, event: React.MouseEvent<HTMLElement>) => {
        setCurrentlySelected(onSight);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [anchorPopOverEl, setPopOverAnchorEl] = React.useState<HTMLElement | null>(null);
    const [hoveredSession, setHoveredSession] = React.useState<ActiveSessionStub | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>, session: ActiveSessionStub) => {
        if (session.policyHolderImage) {
            setHoveredSession(session);
            setPopOverAnchorEl(event.currentTarget);
        }
    };

    const handlePopoverClose = () => {
        setPopOverAnchorEl(null);
    };
    const popOverOpen = Boolean(anchorPopOverEl);
    let hoveredImage = hoveredSession !== null ? hoveredSession.policyHolderImage ?? undefined : undefined;

    return (
        <Fragment>
            <MaterialTable
                title={
                    <Typography variant="h6" style={{ whiteSpace: "nowrap" }}>
                        <Flag fontSize="inherit" /> {props.localizations.ActiveQueue} |{" "}
                        <Button variant="text" size="small" onClick={props.refreshNow}>
                            {Util.format(props.localizations.refreshIn, { refreshTime: props.refreshTimer })}
                        </Button>
                    </Typography>
                }
                localizations={props.localizations}
                options={{
                    grouping: false,
                    draggable: false,
                    search: true,
                    pageSize: 10,
                }}
                columns={[
                    {
                        title: props.localizations.client,
                        grouping: false,
                        customFilterAndSearch: (filter, rowData, columDef) =>
                            `${rowData.company + " " || ""} ${rowData.policyHolderFirstName} ${
                                rowData.policyHolderLastName
                            }`
                                .toLowerCase()
                                .indexOf(filter.toString().toLowerCase()) > -1,
                        render: (rowData) => (
                            <>
                                <Avatar
                                    src={rowData.policyHolderImage}
                                    variant="rounded"
                                    style={{ display: "inline-flex", verticalAlign: "middle", marginRight: 10 }}
                                    onMouseEnter={(evt) => handlePopoverOpen(evt, rowData)}
                                    onMouseLeave={handlePopoverClose}
                                ></Avatar>
                                {`${rowData.company ? rowData.company + ": " : ""} ${rowData.policyHolderFirstName} ${
                                    rowData.policyHolderLastName
                                }`}
                            </>
                        ),
                    },

                    {
                        title: props.localizations.mentor,
                        customFilterAndSearch: (filter, rowData, columDef) =>
                            `${rowData.mentor?.firstName + " " || ""} ${rowData.mentor?.lastName || ""}`
                                .toLowerCase()
                                .indexOf(filter.toString().toLowerCase()) > -1,
                        render: (rowData) => (
                            <>
                                <Avatar
                                    src={rowData.mentor?.photoUrl}
                                    style={{ display: "inline-flex", verticalAlign: "middle", marginRight: 10 }}
                                    variant="rounded"
                                ></Avatar>
                                {rowData.mentor?.firstName} {rowData.mentor?.lastName}
                            </>
                        ),
                    },

                    { title: props.localizations.surveyType, field: "inspectionType" },
                    {
                        title: props.localizations.started,
                        defaultSort: "desc",
                        field: "startedDate",
                        grouping: true,
                        type: "datetime",
                        render: (rowData) => <span>{moment(rowData.startedDate).fromNow()}</span>,
                    },
                    {
                        title: props.localizations.due,
                        field: "dueDate",
                        type: "datetime",
                        render: (rowData) => <span>{moment(rowData.dueDate).calendar()}</span>,
                    },
                ]}
                actions={[
                    {
                        icon: () => (<MenuIcon />) as React.ReactElement<SvgIconProps>,
                        tooltip: props.localizations.actionMenu,
                        onClick: (event, data: ActiveSessionStub) => handleClick(data, event),
                    } as Action<ActiveSessionStub>,
                ]}
                data={activeMentors.map((o) => ({ ...o }))}
            ></MaterialTable>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={popOverOpen}
                anchorEl={anchorPopOverEl}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Avatar src={hoveredImage} className={classes.large} variant="rounded"></Avatar>
            </Popover>
            <Menu id="tile-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem
                    onClick={() => {
                        selectOnGuideStream(currentlySelected);
                    }}
                >
                    <ListItemIcon>
                        <Assistant />
                    </ListItemIcon>
                    <ListItemText>{props.localizations.observerSession}</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <AssignmentInd />
                    </ListItemIcon>
                    <ListItemText>{props.localizations.changeMentor}</ListItemText>
                </MenuItem>
            </Menu>
        </Fragment>
        // </div>
    );
}
